import React, { useState } from "react";
import {
  CCol,
  CDataTable,
  CRow,
  CCardHeader,
  CButton,
  CBadge,
  CCardBody,
  CCard,
} from "@coreui/react";
import TableDateFromat from "./Table/TableDateFromat";
import TableButtonTo from "./Table/TableButtonTo";
import TableButtonAnchor from "./Table/TableButtonAnchor";
import ConfirmationPopup from "./ConfirmationPopup";
import TableButtonClick from "./Table/TableButtonClick";

const CommonList = React.forwardRef((props, ref) => {
  //const [bgapproveopen, setbgapproveopen] = useState(false);
  const [lotpaymentid, setlotpaymentid] = useState();
  const [isTransferLotBG, setisTransferLotBG] = useState();
  const [ABSBGPaymentId, setABSBGPaymentId] = useState();

  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();
  // adding button loader
  const [CPopUpButtonLoader, SetCPopUpButtonLodaer] = useState(false);

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);

  const SubmitConfirmationPopUpResponse = async () => {
    SetCPopUpButtonLodaer(true);
    setCPopUpIndex(-1);
    handleConfirmationPopUpModalClose();
    if (CPopUpId === 1) {
      props.approveBG(lotpaymentid, isTransferLotBG, ABSBGPaymentId);
    } else if (CPopUpId === 2) {
      props.rejectBG(lotpaymentid, isTransferLotBG, ABSBGPaymentId);
    }
  };
  const SetDataCheckNull = (value) => {
    return (
      <td className="py-2">
        <span>{value === null ? "" : value}</span>
      </td>
    );
  };
  const handleApproveRejectCOfirmationOpen = async (
    PopupId,
    id,
    isTransferLotBG,
    paymentId,
    message
  ) => {
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(message);
    setCPopUpId(PopupId);
    setlotpaymentid(id);
    setisTransferLotBG(isTransferLotBG);
    setABSBGPaymentId(paymentId);
  };

  const scopedSlotsCommon = {
    show_details: (item, index) => {
      let id;
      if (props.path === "/lotlistview/") {
        id = window.btoa(item[props.id]);
      } else {
        id = item[props.id];
      }
      return <TableButtonTo to={props.path + id} ButtonName={props.tabBtn} />;
    },

    ConditionalBtn: (item, index) => {
      return (
        !item.isSanctionLetterGenerated && (
          <TableButtonTo
            to={props.path + item[props.id] + "/edit"}
            ButtonName={props.tabBtn}
          />
        )
      );
    },
    insertdateformat: (item, index) => {
      return TableDateFromat(item.insertDateTime);
    },
    District: (item, index) => {
      return SetDataCheckNull(item.disctrict);
    },
    City: (item, index) => {
      return SetDataCheckNull(item.city);
    },
    viewBG: (item, index) => {
      return (
        <TableButtonAnchor
          isDisplayWithOutFileName={true}
          fileName={""}
          path={item.filePath}
          buttonName={"View"}
        />
      );
    },

    approveBG: (item, index) => {
      return (
        <TableButtonClick
          isDisabledBtn={true}
          buttonName={item.paymentType === 6 ? "Approve" : "Generate Agreement"}
          disabled={props.disableApproveReject}
          isDisplayAllow={true}
          onClick={() =>
            handleApproveRejectCOfirmationOpen(
              1,
              item.lotPaymentId,
              item.isTransferLotBG,
              item.paymentId,
              `Are you sure you want to ${
                item.paymentType === 6 ? "Approve" : "Generate Agreement"
              }?`
            )
          }
        />
      );
    },
    rejectBG: (item, index) => {
      return (
        <TableButtonClick
          isDisabledBtn={true}
          buttonName={"Reject"}
          disabled={props.disableApproveReject}
          isDisplayAllow={true}
          onClick={() =>
            handleApproveRejectCOfirmationOpen(
              2,
              item.lotPaymentId,
              item.isTransferLotBG,
              item.paymentId,
              "Are you sure you want to Reject?"
            )
          }
        />
      );
    },
    EditionInRow: (item, index) => {
      return SetDataCheckNull(
        item.status === true ? (
          <CBadge color="success" className={"badgeFont100"}>
            Active
          </CBadge>
        ) : (
          <CBadge color="danger" className={"badgeFont100"}>
            Inactive
          </CBadge>
        )
      );
    },
    Street: (item, index) => {
      return SetDataCheckNull(item.streetName);
    },
  };

  // eslint-disable-next-line no-unused-vars
  const [scopedSlots, setScopedSlots] = useState({
    ...scopedSlotsCommon,
    ...props.scopedSlots,
  });
  // const scopedSlots = {
  //   ConditionalBtn: (item, index) => ConditionalBtn(item, path, id, tabBtn),
  //   props.scopedSlots
  // };
  return (
    <CCard>
      {props.listName !== "" && (
        <CCardHeader>
          {props.isBackButton === true ? (
            <CRow xl={12} className="mt-2">
              <CCol xl={10}>
                <h3 className="titlehr">{props.listName}</h3>
              </CCol>
              <CCol xl={2} className={"text-end"} style={{ textAlign: "end" }}>
                <CButton
                  className="ml-3 btn btn-success"
                  to={props.backButtonTo}
                >
                  {props.backButtonName === "" ||
                  props.backButtonName === undefined
                    ? "Back"
                    : props.backButtonName}
                </CButton>
              </CCol>
            </CRow>
          ) : (
            <CRow className="mt-2">
              <CCol xl={12}>
                <h3>{props.listName}</h3>
              </CCol>
            </CRow>
          )}
        </CCardHeader>
      )}
      <CCardBody>
        {props.additional}
        {props.isAfterSearchDataDisplay &&
        props.isAfterSearchDataDisplay === true ? (
          // props.items ? (
          <CRow className="mt-3 removet-3">
            <CCol xl={12}>
              <CDataTable
                noItemsView={{
                  noResults: "Custom message here",
                  noItems: " Record Not Found",
                }}
                items={props.items}
                fields={props.fields}
                hover
                addTableClasses="table table-striped"
                responsive
                border
                loading={props.loading}
                itemsPerPage={3}
                scopedSlots={scopedSlots}
              />
            </CCol>
          </CRow>
        ) : (
          // ) : (
          //   <></>
          // )
          <CRow className="mt-3 removet-3">
            <CCol xl={12}>
              <CDataTable
                items={props.items}
                fields={props.fields}
                hover
                addTableClasses="table table-striped"
                responsive
                border
                loading={props.loading}
                itemsPerPage={3}
                scopedSlots={scopedSlots}
              />
            </CCol>
          </CRow>
        )}
        {props.displayPaggingButton !== false && (
          <CRow className="float-right mt-2">
            <CButton
              className="m-2"
              color="success"
              onClick={props.prev}
              disabled={props.disabledprev}
              style={{ visibility: props.disabledprev ? "hidden" : "visible" }}
            >
              Prev
            </CButton>
            <CButton
              className="m-2"
              color="success"
              onClick={props.next}
              disabled={props.disablednext}
              style={{ visibility: props.disablednext ? "hidden" : "visible" }}
            >
              Next
            </CButton>
          </CRow>
        )}
        {props.deleteBtn !== undefined && <div>{props.deleteBtn} </div>}
        {props.markedResult}
      </CCardBody>

      <ConfirmationPopup
        showModal={CPopUpDisplayConfirmationModal}
        hideModal={handleConfirmationPopUpModalClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={CPopUpId}
        index={CPopUpIndex}
        ModalBody={CPopUpBodyText}
        //ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        ButtonLoader={CPopUpButtonLoader}
      />
    </CCard>
  );
});

export default CommonList;
